import React, { useState, useEffect, useRef } from 'react';
import { Controller } from "react-hook-form";
import { useLazyGetJobsQuery } from "context/utils/jobsApiSlice";
import { useLazyGetProductQuery } from 'context/product/productApiSlice';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListSubheader from '@mui/material/ListSubheader';
import { Divider } from '@mui/material';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";

// Material Kit 2 React components
import MKButton from "dashboard/components/MDButton";
// import { ListItemText } from '@mui/material';
import MDTypography from 'dashboard/components/MDTypography';


const filter = createFilterOptions();
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

const names = [
  'Administrator',
  'Manager',
  'Editor',
  'Visitor',
  'Distributor'
];

const BasicSelect = ({label, options, size,samevalue=false, ...props}) => {
  return (
      <FormControl sx={{ minWidth: 120, minHeight:36, "& .MuiInputBase-sizeSmall, & .MuiInputBase-root":{minHeight: size === "medium" ? 45 :38 } }} size={size || "small"} fullWidth>
        <InputLabel id={`simple-${label}`}>{label}</InputLabel>
        <Select
          { ...props}
          labelId={`simple-${label}`}
          id={`simple-select-${label}`}
          label={label}
          MenuProps={MenuProps}
        >
          {options.map((ele, i)=><MenuItem key={`itemselect-${i}`} value={samevalue ? ele : i}>{ele.name}</MenuItem>)}
        </Select>
      </FormControl>
  );
}

const OptionsSelect = ({onChange, options,selected,id, samevalue = false}) => {
  const [option, setOption] = useState(0);

  const handleChange = (event) => {
    setOption(event.target.value);
    onChange(id, event.target.value);
  };

  useEffect(() => {
    selected && setOption(selected);
  }, [selected])

  return (
      <FormControl sx={basicSelectStyle} size="small" fullWidth>
        <InputLabel id="demo-options-select-label">Agir</InputLabel>
        <Select
          labelId="demo-options-select-label"
          id="demo-options-select"
          value={option}
          onChange={handleChange}
          MenuProps={MenuProps}
          size="small"
        >
          {options.map((ele, i)=><MenuItem key={`itemselect-${i}`} value={samevalue ? ele : i}>{ele}</MenuItem>)}
        </Select>
      </FormControl>
  );
}
const basicSelectStyle = { minWidth: 120 , "& .MuiInputBase-sizeSmall":{minHeight:38}};
const StandardSelect = ({ label, onChange, options, index, value, samevalue=false, isObject = false, ...props }) => {
  const [state, setState] = useState(value);

  const handleChange = (event) => {
    setState(event.target.value);
    onChange(event);
  };

  useEffect(() => {
    value !== undefined && setState(value);
  }, [value]);

  return (
      <FormControl sx={basicSelectStyle} size="small" fullWidth>
        <InputLabel id={`simple-${label}-${index}`}>{label}</InputLabel>
        <Select
          { ...props}
          value={state}
          labelId={`simple-${label}-${index}`}
          id={`simple-select-${label}-${index}`}
          MenuProps={MenuProps}
          onChange={handleChange}
        >
          {options.map((ele, i)=>
          isObject ?
          <MenuItem key={`itemselect-${i}`} value={ele.value}>{ele.name}</MenuItem>
          : <MenuItem key={`itemselect-${i}`} value={samevalue ? ele : i}>{ele ===0 ? "rayon (km)" : ele}</MenuItem> 
          )}
        </Select>
      </FormControl>
  );
}

const SelectMutipple = (props) => {
    
    const {selected, action, attribute} =  props;
    const [personName, setPersonName] = useState(selected || []);

    const handleChange = (event) => {
      const {
        target: { value },
      } = event;
      /* eslint-disable */

      setPersonName(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
      );
      
    };

    const handleClose = ()=>{
      selected !== personName && action(attribute,personName);
    }

    useEffect(() => {
      setPersonName(
        // On autofill we get a stringified value.
        typeof selected === 'string' ? selected.split(',') : selected,
      );
    }, [selected])

    return (
      <div>
        <FormControl sx={{ m: 1, width: 200,  }}>
          <InputLabel id="demo-multiple-checkbox-label">Role</InputLabel>
          <Select
            sx={{ minHeight:36 }}
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={personName}
            onChange={handleChange}
            input={<OutlinedInput label="Tag" />}
            renderValue={  selected => selected.join(', ')}
            MenuProps={MenuProps}
            onClose={handleClose}
          >
            {names.map((name) => (
              <MenuItem sx={{p:.3,m:.3}} key={name} color="success" value={name}>  
                <MDTypography sx={{fontSize:14}} >
                <Checkbox  color="primary"  variant="soft" checked={personName.indexOf(name) > -1} />
                {name}</MDTypography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
}
const PagesSelect = ({onChange, selected, parent, dataid, links}) => {
  const [link, setLink] = useState("");
  const selectedIcon = useRef();
  
  const handleChange = event => {
    setLink(event.target.value);
    const item = links.find( item => item.name === event.target.value);
    selectedIcon.current =  Number(item.type === 2) ? "tag" : "exit_to_app"
    onChange(dataid, item, parent);
  };

  useEffect(() => {
    selected.name  && setLink(selected.name);
    selectedIcon.current =  Number(selected.type) === 2 ? "tag" : "exit_to_app"
  }, []);

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Lien vers</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={link}
          label="link to"
          onChange={handleChange}
          MenuProps={MenuProps}
          sx={{ minHeight:"45px", "& .MuiSelect-select":{display: "flex !important", alignItems: "center", justifyContent: "space-between"}}}
          size="medium"
          name="link"
          dataid={dataid}
          renderValue={value => <>{value.toString()} <Icon>{selectedIcon.current}</Icon></>}
        >
          {links.length !== 0 && links.map( item =>(
            item.hasOwnProperty('value') ? (<ListSubheader key={`name-header-${item.name}`}  sx={{fontWeight:800, color:"primary.main", backgroundColor:"#f7f7f7"}} value="">{item.name}<Divider sx={{my:0, width:"100%"}}/></ListSubheader>)
             : <MenuItem  key={`name-${item.name}`} value={item.name}>{item.name}</MenuItem>
          ))}   
        </Select>
      </FormControl>
    </Box>
  );
}
const  MDDropdown = ({ list, color,variant, selected, action, attribute, textAlign, width="100px"}) => {
 
  const [dropdown, setDropdown] = useState(null);
  const [selectedvalue, setSelectedValue] = useState(null);
  const ARRAY_SORT = ["dateASC","dateDESC","priceASC","priceDESC", "poular", "nearest"];

  const openDropdown = ({ currentTarget }) => {
    setDropdown(currentTarget);
  }
  const closeDropdown = select => {
    if( select ) {
      setSelectedValue(select)
      const value = attribute === "sortBy" ? ARRAY_SORT[list.indexOf(select)] : select;
      attribute ? action({[attribute]:value}) : action(value);
    }
    setDropdown(null);
  }
  useEffect(() => {
    setSelectedValue(attribute === "sortBy" ? list[ARRAY_SORT.indexOf(selected)] : selected);
  }, [selected])
  
  // Styles
  const iconStyles = {
    ml: 1,
    fontWeight: "bold",
    transition: "transform 200ms ease-in-out",
  };

  const dropdownIconStyles = {
    transform: dropdown ? "rotate(180deg)" : "rotate(0)",
    ...iconStyles,
  };

  return (
          <Box display="inline-block" mr={1} textAlign={textAlign}>
            <MKButton sx={{px:1, boxShadow: 2}}  color={color} variant={variant} onClick={openDropdown}>
              <span style={{whiteSpace:'normal',  minWidth:width}}>{selectedvalue}</span> <Icon sx={dropdownIconStyles}>expand_more</Icon>
            </MKButton>
            <Menu anchorEl={dropdown} open={Boolean(dropdown)} onClose={ e => closeDropdown(null)}>
              {list.map( item => <MenuItem key={item}  onClick={ e => closeDropdown(item)}>{item}</MenuItem>)}
            </Menu>
          </Box>
  );
}

const  MDDropup = () => {
  const [dropup, setDropup] = useState(null);

  const openDropup = ({ currentTarget }) => setDropup(currentTarget);
  const closeDropup = () => setDropup(null);

  // Styles
  const iconStyles = {
    ml: 1,
    fontWeight: "bold",
    transition: "transform 200ms ease-in-out",
  };

  const dropupIconStyles = {
    transform: dropup ? "rotate(180deg)" : "rotate(0)",
    ...iconStyles,
  };

  return (
    
          <Grid item xs={12} lg={6} textAlign="center">
            <MKButton variant="gradient" color="info" onClick={openDropup}>
              Dropup <Icon sx={dropupIconStyles}>expand_more</Icon>
            </MKButton>
            <Menu
              anchorEl={dropup}
              open={Boolean(dropup)}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              onClose={closeDropup}
            >
              <MenuItem onClick={closeDropup}>Action</MenuItem>
              <MenuItem onClick={closeDropup}>Another action</MenuItem>
              <MenuItem onClick={closeDropup}>Something else here</MenuItem>
            </Menu>
          </Grid>
  );
}

export const JobsSelect = ({ onChange: ignored, control, selected, register}) => {

  const [open, setOpen] = useState(false);
  const [fetchJobs,{isLoading}] = useLazyGetJobsQuery();
  const [jobsList, setJobsList] = useState([]);
  const loading = open;
  const [defaultValue, setDefaultValue] = useState(null);

  const loadJobsList  = async ()=>{
    const { data } = await fetchJobs();
    setJobsList(Object.values(data.entities));
  }

  useEffect( async () => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    if ( active ) {    
      jobsList?.length === 0  && loadJobsList();
    }

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    selected && setDefaultValue(selected);
  }, [selected])

  return (
    <Controller render={({ field: { onChange, props } }) => (
      <Autocomplete 
        id="asynchronous-job"
        {...register("job", { required: "Please chose your job"})}
        autoComplete={false}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={defaultValue}
        onChange={(event, value, reason, details) => {
          setDefaultValue(value);
          onChange(value)
        }}
        {...props}
        isOptionEqualToValue={(option, value) => option.id ===  Number(defaultValue.id) }
        getOptionLabel={(option) =>  option && option.jobName }
        size="medium"
        options={jobsList}
        loading={isLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select a job"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              style:{ padding : "5px" }
            }}
          />
        )}
        
      />
    )}
    onChange={([, data]) => data}
    defaultValue={defaultValue}
    autoComplete="off"
    name="job"
    control={control}
    />
  );
}

export const ProductsSelect = ({onChange, value, fildName, label,dataid, ...props}) => {

  const [open, setOpen] = useState(false);
  const [fetchProducts,{ isLoading , isFetching, isSuccess}] = useLazyGetProductQuery();
  const [productsList, setProductsList] = useState([]);
  const [name, setName] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);

  const loadProductsList  = async (name)=>{
    const { data } = await fetchProducts({name});
    setProductsList(Object.values(data.entities));
  }


  useEffect( async () => {
    let active = true;
    if ( !isLoading &&  active ) {    
       loadProductsList(name);
    }

    return () => {
      active = false;
    };
  }, [isLoading,name]);

  useEffect(() => {
    value && setDefaultValue(value);
  }, [value])

  let typingTimeout;
  const handleSearch = event => {
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(()=> {
      setName(event.target.value)
    }, 500);
  }
  return (
      <Autocomplete 
        {...props}
        id={`asynchronous-product-${dataid}`}
        autoComplete="off"
        open={open}
        freeSolo
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        value={defaultValue}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            setDefaultValue(newValue?.replace("Entrer ",""));
          } else if (newValue && newValue.productName) {
            // Create a new value from the user input
            setDefaultValue(newValue.productName);
          } else {
            setDefaultValue(newValue?.replace("Entrer ",""));
          }
          onChange(typeof newValue === "string" ? newValue?.replace("Entrer ","") : newValue , dataid );
        }}

          filterOptions={(options, params) => {
          const filtered = filter(options, params);
  
          const { inputValue } = params;
          // Suggest the creation of a new value
          const isExisting = options.some((option) => inputValue === option);
          if (inputValue !== '' && !isExisting) {
            filtered.push(`Entrer ${inputValue}`);
          }
          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        isOptionEqualToValue={(option, value) => option.id ===  Number(defaultValue.id) }
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.productName) {
            return option.productName;
          }
          // Regular option
          return option.title;
        }}
        size="medium"
        options={productsList}
        loading={open && (isLoading || isFetching)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Tapez un titre ou un nom du produit"
            onChange={handleSearch}
            value={name}
            InputProps={{
              ...params.InputProps,
              autoComplete: 'off',
              form: {
                autoComplete: 'off',
              },
              endAdornment: (
                <>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              style:{ padding : "5px" }
            }}
          />
        )}
        
      />
  );
}

const FormatSelect = ({onChange, selected}) => {
  const [format, setFormat] = useState('');

  const handleChange = (event) => {
    setFormat(event.target.value);
    onChange(event);
  };

  useEffect(() => {
    selected !== undefined && setFormat(selected);
  }, [selected])

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-format-select-label">choisir un format</InputLabel>
        <Select
          labelId="demo-format-select-label"
          id="demo-format-select"
          value={format}
          label="gender"
          onChange={handleChange}
          MenuProps={MenuProps}
          sx={{ minHeight:"45px"}}
          size="small"
          name="format"
        >
          <MenuItem value={0}>csv</MenuItem>
          <MenuItem value={1}>xls</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export  { MDDropdown, MDDropup, PagesSelect, BasicSelect , StandardSelect, FormatSelect, OptionsSelect};

export default SelectMutipple